import dayjs from 'dayjs'

export const getIsNeedUpdateStoreState = (lastLoadDate: Date | null, loadPeriodInMilliseconds: number) =>
  !lastLoadDate || dayjs().diff(dayjs(lastLoadDate)) >= loadPeriodInMilliseconds
